export default function GeneralIcon() {
  return (
    <svg
      width="23"
      height="22"
      viewBox="0 0 23 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4264_12900)">
        <path
          d="M12.8341 9.1781C15.3538 9.1781 17.8787 9.24145 20.392 9.15435C21.9441 9.10156 22.9337 10.4344 22.3891 11.9653C21.4487 14.6047 20.6287 17.2783 19.7517 19.9375C19.3843 21.0513 18.7997 21.4736 17.6381 21.4749C12.5767 21.4749 7.51532 21.4842 2.45391 21.4604C1.98644 21.4499 1.52809 21.3264 1.11645 21.1001C0.490399 20.7557 0.357165 20.249 0.561535 19.5416C1.40489 16.6216 2.25083 13.7015 3.09936 10.7815C3.44731 9.58589 3.98152 9.18206 5.20904 9.17942C7.75203 9.17414 10.2924 9.1781 12.8341 9.1781Z"
          fill="white"
        />
        <path
          d="M11.4141 8.2211C9.53859 8.2211 7.66304 8.20922 5.78878 8.22901C5.19895 8.22901 4.93119 8.06142 4.94801 7.39761C4.98681 5.83775 4.95577 4.27523 4.96224 2.71405C4.96224 1.39436 5.7047 0.642142 7.01629 0.638182C9.15054 0.631584 11.2848 0.623667 13.419 0.65138C13.7318 0.660531 14.0319 0.779376 14.2689 0.987898C15.4058 2.09775 16.5144 3.23137 17.6074 4.39137C17.7843 4.6001 17.8885 4.86277 17.9036 5.13831C17.9411 5.90637 17.8919 6.67838 17.9256 7.44644C17.9514 8.02578 17.7173 8.23034 17.1702 8.22638C15.2545 8.2211 13.3324 8.2211 11.4141 8.2211ZM14.3154 2.42636C13.9791 4.11027 14.7035 4.82291 16.1574 4.3333L14.3154 2.42636Z"
          fill="white"
        />
        <path
          d="M0.318654 9.89279C0.318654 8.72883 0.309599 7.56354 0.318654 6.39958C0.327708 5.23562 1.07793 4.45304 2.22266 4.45568C4.21463 4.45568 4.03354 4.16535 4.03354 6.24914C4.03354 6.42465 4.02578 6.60017 4.03354 6.77701C4.0814 7.66648 4.09175 8.46753 3.11517 8.99672C2.69867 9.22239 2.44256 9.88619 2.26018 10.4048C1.88507 11.4764 1.63154 12.5902 1.27583 13.6684C1.20081 13.8967 0.899424 14.0472 0.70152 14.2332C0.572172 13.9944 0.334174 13.7595 0.32512 13.518C0.296663 12.3131 0.318654 11.1003 0.318654 9.89279Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_4264_12900">
          <rect
            width="22.2298"
            height="20.8405"
            fill="white"
            transform="translate(0.310547 0.631836)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
